import Vue from 'vue'
import VueI18n from 'vue-i18n'
import locale from 'element-ui/lib/locale'
import zhCN from './langs/zh'
import en from './langs/en'
import zhTW from './langs/zh-TW'
import ja from './langs/ja'
import ko from './langs/ko'
import vi from './langs/vi'
import ptBr from './langs/pt-br'
import ru from './langs/ru'
import enLocale from 'element-ui/lib/locale/lang/en'
import zhCNLocale from 'element-ui/lib/locale/lang/zh-CN'
import zhTWLocale from 'element-ui/lib/locale/lang/zh-TW'
import jaLocale from 'element-ui/lib/locale/lang/ja'
import koLocale from 'element-ui/lib/locale/lang/ko'
import viLocale from 'element-ui/lib/locale/lang/vi'
import ptBrLocale from 'element-ui/lib/locale/lang/pt-br'
import ruLocale from 'element-ui/lib/locale/lang/ru-RU'

Vue.use(VueI18n)

const messages = {
  'en': Object.assign(en, enLocale),
  'zh-cn': Object.assign(zhCN, zhCNLocale),
  'zh-tw': Object.assign(zhTW, zhTWLocale),
  'ja': Object.assign(ja, jaLocale),
  'ko': Object.assign(ko, koLocale),
  'vi': Object.assign(vi, viLocale),
  'pt-br': Object.assign(ptBr, ptBrLocale),
  'ru': Object.assign(ru, ruLocale)
}

function getCurrentLanguage () {
  let cache = sessionStorage.getItem('locale')
  if (cache != null && typeof cache !== 'undefined') {
    return cache
  }
  let localSetting = (navigator.language) ? navigator.language : navigator.userLanguage
  if (localSetting != null && typeof localSetting !== 'undefined' && localSetting.length > 0) {
    console.log('local setting is:', localSetting.toLocaleLowerCase())
    let lCode = localSetting.toLocaleLowerCase()
    if (lCode.indexOf('zh') === 0) {
      if (lCode === 'zh-tw' || lCode === 'zh-hk') {
        return 'zh-tw'
      }
      return 'zh-cn'
    } else if (lCode.indexOf('en') === 0) {
      return 'en'
    } else if (lCode.indexOf('ja') === 0) {
      return 'ja'
    } else if (lCode.indexOf('ko') === 0) {
      return 'ko'
    } else if (lCode.indexOf('vi') === 0) {
      return 'vi'
    } else if (lCode.indexOf('pt-br') === 0) {
      return 'pt-br'
    } else if (lCode.indexOf('ru') === 0) {
      return 'ru'
    }
  }
  // default language is english
  return 'en'
}

const i18n = new VueI18n({
  locale: getCurrentLanguage(),
  fallbackLocale: 'en',
  messages
})

locale.i18n((key, value) => i18n.t(key, value))
export default i18n
